import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";
import { AnalyticsEvent } from "@services/tracking/types/analyticsEvent";

import EventDataLayer from "../../queue/EventDataLayer";
import { SubscriberCallback } from "../../queue/SubscriberCallback";

const DebugSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false,
) => {
    eventDataLayer.subscribe("debugger", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (
    event: string,
    data: AnalyticsEvent,
): void => {
    if (FeatureToggles.isEnabled(FeatureToggleKeys.EVENT_DATA_LAYER_LOGGING)) {
        console.groupCollapsed(`hubo:EventDataLayer:debugger - event`, event);
        console.log(data);
        console.groupEnd();

        if (
            typeof window != "undefined" &&
            window != null &&
            typeof window.sessionStorage !== "undefined"
        ) {
            let eventLog = window.sessionStorage.getItem("eventLog");
            eventLog += "," + JSON.stringify(data);
            window.sessionStorage.setItem("eventLog", `${eventLog}`);
            window.postMessage("analytics-track-change", "*");
        }
    }
};

export { DebugSubscriber };
